import styles from './index.module.sass';
import mochi from '../../../../domain/assets/loadingMochi.svg';

const SpinnerMochi = () => (
  <div
    className={styles.spinner}
    style={{ WebkitMaskImage: `url(${mochi})`, maskImage: `url(${mochi})` }}
  />
);
export default SpinnerMochi;
